import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic } from "../../utils/siteUtils";
import { mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, Image } from "../../elements";
import "./style.scss";
import { gtag } from "../../utils";
import gsap from 'gsap';
import { debounce } from "lodash";

const HorizontalScrolling = props => {
	const { lang, rendering, fields, page } = props;
	const { list } = fields;
	const [isActive, setIsActive] = useState(false);
	const [toLeft, setToLeft] = useState(false);
	const [toLeft1, setToLeft1] = useState(false);
	const isMobile = mobileIs()
	const rootNode = useRef()
	const contentEl = useRef()
	const isAR = page?.fields?.rtl?.value;
	
	const onScroll = () => {
		let rootNodeTop = rootNode.current.getBoundingClientRect().top;
		if(rootNodeTop < 150) {
			setIsActive(true);
		} else {
			setIsActive(false);
		}
	};
	
  useEffect(() => {
		let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth;
  	let length = list.length - 1;
		let ScrollMagic, controller, scene, tl;
  	ScrollMagic = loadScrollMagic();
  	controller = new ScrollMagic.Controller();
  	tl = gsap.timeline();
  	tl.add(gsap.to(contentEl.current,{
			x: isMobile ? (isAR ? pageWidth * 1 * length + 'px' : pageWidth * -1 * length + 'px') : (isAR ? (pageWidth * 0.4 + 140) * 1 * length + 140 + 'px' : (pageWidth * 0.4 + 140) * -1 * length - 140 + 'px')
  	}), 0.3) // 数值对应的是从progress百分之多少开始执行动画
  	
  	scene = new ScrollMagic.Scene({
  	  triggerElement: rootNode.current,
  	  triggerHook: 0,
  	  duration: window.innerHeight * length
  	})
		.setPin(rootNode.current)
  	.setTween(tl)
  	.addTo(controller)
		
		scene.on("progress", function(event) {
			// console.log(event.progress > 0.3)
			if (event.progress > 0.3) {
				setToLeft(true);
			} else {
				setToLeft(false);
			}
			
			if (event.progress > 0.5) {
				setToLeft1(true);
			} else {
				setToLeft1(false);
			}
		});
		
		window.addEventListener("scroll", onScroll);
  	return () => {
  	  scene.destroy(true);
  	  scene = null;
  	  controller.destroy(true);
  	  controller = null;
			window.removeEventListener("scroll", onScroll);
  	};
  }, [])
	
	const rootClasses = classNames("c-horizontal-scrolling", isAR ? 'rtl' : '', getOverallSettingsClasses(fields));
	return (
		<div className={rootClasses} ref={rootNode} datasourceid={rendering.dataSource}>
			<div className="c-horizontal-scrolling_content" ref={contentEl}>
				{list.length && list.map((item, index) => {
					return (
						<div className={classNames("c-horizontal-scrolling_content_item", index > 0 ? 'active' : '')} key={index}>
							{index == 0 && !isMobile && <BackgroundImage {...item?.fields?.pc_image} className="c-horizontal-scrolling_content_item_background">
								{!isMobile && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_title", isActive ? 'active' : '', toLeft ? 'toLeft' : '')} field={item.fields.pc_title} />}
								{!isMobile && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_subtitle", isActive ? 'active' : '', toLeft ? 'toLeft' : '')} field={item.fields.pc_subtitle} />}
								{!isMobile && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_descripition", isActive ? 'active' : '', toLeft ? 'toLeft' : '')} field={item.fields.pc_descripition} />}
							</BackgroundImage>}
							{index == 0 && isMobile && <BackgroundImage {...item?.fields?.m_image} className="c-horizontal-scrolling_content_item_background">
								{isMobile && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_title", isActive ? 'active' : '', toLeft ? 'toLeft' : '')} field={item.fields.m_title} />}
								{isMobile && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_subtitle", isActive ? 'active' : '', toLeft ? 'toLeft' : '')} field={item.fields.m_subtitle} />}
								{isMobile && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_descripition", isActive ? 'active' : '', toLeft ? 'toLeft' : '')} field={item.fields.m_descripition} />}
							</BackgroundImage>}
							{!isMobile && index > 0 && <img className={classNames("c-horizontal-scrolling_content_item_image", toLeft1 ? 'toLeft' : '')} src={item?.fields?.pc_image?.value.src} />}
							{!isMobile && index > 0 && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_sectitle", toLeft1 ? 'toLeft' : '')} field={item.fields.pc_title} />}
							{!isMobile && index > 0 && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_secdescripition", toLeft1 ? 'toLeft' : '')} field={item.fields.pc_descripition} />}
							{isMobile && index > 0 && <img className={classNames("c-horizontal-scrolling_content_item_image", toLeft1 ? 'toLeft' : '')} src={item?.fields?.m_image?.value.src} />}
							{isMobile && index > 0 && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_sectitle", toLeft1 ? 'toLeft' : '')} field={item.fields.m_title} />}
							{isMobile && index > 0 && <RichText tag="div" className={classNames("c-horizontal-scrolling_content_item_secdescripition", toLeft1 ? 'toLeft' : '')} field={item.fields.m_descripition} />}
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default 	HorizontalScrolling;